/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RestrictionMixinSetPasswordParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('set')],
    ['password', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class RestrictionMixinSetPassword extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RestrictionMixinSetPasswordParser.decode(input).map(res => new RestrictionMixinSetPassword(res));
    }
    static unsafeDecode(input) {
        return RestrictionMixinSetPassword.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RestrictionMixinSetPasswordParser.encode(data);
    }
    static schema() {
        return RestrictionMixinSetPasswordParser.schema();
    }
}
